import { Minus, Plus } from "lucide-react"

import { classNames } from "../../../../lib/classNames"
import { LucideIconComponent, IconSizes } from "../LucideIcon"
import { LucideIconProps } from "../LucideIcon/LucideIcon"

export interface TableHeaderGroupToggleProps extends Partial<LucideIconProps> {
  isExpanded?: boolean
  onToggle?: () => void
}

export function TableHeaderGroupToggle({
  isExpanded,
  onToggle,
  className,
  ...otherProps
}: TableHeaderGroupToggleProps) {
  const Icon = isExpanded ? Minus : Plus

  return (
    <LucideIconComponent
      Icon={Icon}
      wrapperSize={IconSizes.Small}
      iconSize={IconSizes.ExtraSmall}
      onClick={onToggle}
      className={classNames(
        "color-subtle rounded-mark bg-elevation-surface-hovered cursor-pointer",
        className
      )}
      {...otherProps}
    />
  )
}
